import React from "react";
import PageHero from "../components/PageHero";
import Seo from "../components/seo/Seo";
import JsonLd from "../components/seo/JsonLd";
import SponsorshipForm from "../components/forms/SponsorshipForm";
import { ROUTES, breadcrumbs } from "../lib/seo";

/**
 * Form C — sponsorship and partnerships. The hero is short and the form
 * follows it straight away (unlike /host/, which makes its case first).
 */
export default function Sponsorship() {
  return (
    <>
      <Seo route={ROUTES.sponsorship} />
      <JsonLd data={breadcrumbs([{ name: ROUTES.sponsorship.crumb, path: ROUTES.sponsorship.path }])} />

      <PageHero
        eyebrow="Sponsorship"
        title={<>Be part of the <span className="gold-grad italic">room</span></>}
        intro="Antara's October editions in Delhi and Chandigarh both sold out. If your brand belongs in a hall full of people singing together, tell us what you have in mind."
      />

      <section className="bg-[#120C08] pt-12 pb-24 md:pt-16 md:pb-32 px-5" data-testid="sponsorship-section">
        <SponsorshipForm tone="dark" />
      </section>
    </>
  );
}
